import type { JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import './index.css';

type NotificationType = 'error' | 'warning' | 'info' | 'success';

interface NotificationProps {
  type?: NotificationType;
  titleKey: string | ReactNode;
  subtitleKey: string | ReactNode;
}


const Notification = ({
  type = 'error',
  titleKey,
  subtitleKey
}: NotificationProps): JSX.Element => {
  const { t } = useTranslation();

  const variantClass = type === 'error' ? 'negative' : type;

  const titleText =
    typeof titleKey === 'string' ? t(titleKey) : titleKey;

  const subtitleText =
    typeof subtitleKey === 'string' ? t(subtitleKey) : subtitleKey;

  return (
    <div className={`sprout-alert ${variantClass}`}>
      <div className="sprout-alert--icon-container">
        <ErrorOutlineIcon />
      </div>

      <div className="sprout-alert--content">
        <div className="sprout-alert--message">
          <span className="sprout-alert--title">
            {titleText}
          </span>

          <span className="sprout-alert--subtitle">
            {subtitleText}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Notification;